import { BlogPostSummary } from '@/models/blog/blogPostSummary';

export class BlogPost extends BlogPostSummary {
  public content: string | undefined = undefined;
}
